import { VStack } from "@chakra-ui/react";
import LoginForm from "../components/login_form";

const LoginPage = () => {
  console.log("TEST")
  return (
    <VStack w="100%" minH="100vh" justify="center">
      <LoginForm />
    </VStack>
  );
};

export default LoginPage;
